import styled, { css } from "styled-components";

import { colorsPalettes, fonts } from "@similarweb/styles";

import { DeltaDirections } from "app/pages/sales-intelligence/sub-modules/signals/types/enums";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const divider = css`
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
`;

export const StyledSignalName = styled.h5`
    color: ${colorsPalettes.carbon["500"]};
    font-family: ${fonts.$robotoFontFamily};
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    margin: 0;
    user-select: none;

    b,
    strong {
        font-weight: 700;
    }
`;

export const StyledSignalDescription = styled.p`
    color: ${colorsPalettes.carbon["300"]};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin: 0;
`;

export const StyledDirectionDeltaWrapper = styled(FlexRow)`
    justify-content: center;
    align-items: center;
`;

export const StyledDirectionDeltaValue = styled.div<{ direction: DeltaDirections }>`
    display: flex;
    align-items: center;
    color: ${({ direction }) => {
        switch (direction) {
            case DeltaDirections.UP:
                return `${colorsPalettes.green.s100}`;
            case DeltaDirections.DOWN:
                return `${colorsPalettes.red.s100}`;
            default:
                return `${colorsPalettes.carbon["300"]}`;
        }
    }};
`;
